/**
 * @file Right-pointing chevron icon for breadcrumb separators and
 *       expandable rows.
 * @module @labcraft/ui/icons/chevron-right
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Right-pointing chevron icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function ChevronRightIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 8 12"
      width={8}
      height={12}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <polyline points="2,2 6,6 2,10" />
    </svg>
  )
}
